import { ButtonBase, Container } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'

import { AcIcon, AcTypography } from '@components'
import { ICONS } from '@constants'
import { ISingleAudience } from '@typings'

interface IContentpageLinkgrid extends Partial<ISingleAudience> {
  onClick: () => void
}

export const ContentpageLinkgridLink = ({
  name,
  description,
  onClick,
}: IContentpageLinkgrid) => {
  const [searchParams] = useSearchParams()
  const highlightTerm = searchParams.get('highlight') || ''

  const highlightedName = useMemo(() => {
    if (!highlightTerm || !name) return name

    const parts = name.split(new RegExp(`(${highlightTerm})`, 'gi'))
    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === highlightTerm.toLowerCase() ? (
            <mark
              key={i}
              style={{ backgroundColor: '#ffeb3b', padding: '0 2px' }}>
              {part}
            </mark>
          ) : (
            part
          ),
        )}
      </>
    )
  }, [name, highlightTerm])

  const highlightedDescription = useMemo(() => {
    if (!highlightTerm || !description) return description

    const parts = description.split(new RegExp(`(${highlightTerm})`, 'gi'))
    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === highlightTerm.toLowerCase() ? (
            <mark
              key={i}
              style={{ backgroundColor: '#ffeb3b', padding: '0 2px' }}>
              {part}
            </mark>
          ) : (
            part
          ),
        )}
      </>
    )
  }, [description, highlightTerm])

  return (
    <ButtonBase
      onClick={onClick}
      sx={({ palette }) => ({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
        alignItems: 'flex-start',
        padding: '1rem',
        width: '100%',
        height: '100%',
        justifyContent: 'flex-start',
        border: `1px solid ${palette.grey[300]}`,
        marginBottom: '1px',
        borderRadius: '.25rem',
        transition: 'border-color 0.25s ease',
        '&:hover': {
          borderColor: palette.primary.light,
          borderBottom: `2px solid ${palette.primary.light}`,
          marginBottom: 0,
        },
      })}>
      <Container
        disableGutters
        sx={({ palette }) => ({
          display: 'flex',
          justifyContent: 'space-between',
          color: palette.primary.light,
        })}>
        <AcTypography
          size="l"
          weight="bold">
          {highlightedName}
        </AcTypography>
        <AcIcon icon={ICONS.ARROW_FORWARD} />
      </Container>
      <AcTypography>{highlightedDescription}</AcTypography>
    </ButtonBase>
  )
}
